import React,{useEffect,useState} from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Row, Col, Container } from "react-bootstrap";
import { getLoginUrl,randomCount } from "../../utils/common";
import Carousel1 from "../../assets/images/reg1.jpg";
import Carousel2 from "../../assets/images/reg2.jpg";
import Carousel3 from "../../assets/images/reg3.jpg";
import Carousel4 from "../../assets/images/reg4.jpg";
import Carousel5 from "../../assets/images/reg5.jpg";
import Carousel6 from "../../assets/images/reg6.jpg";
import Carousel7 from "../../assets/images/reg7.jpg";
import Carousel9 from "../../assets/images/reg9.jpg";

const VerificationSuccess = (props) => {
  const { t } = useTranslation();
  const [imageIndex, setImageIndex] = useState(null);
  const [carouselImages] = useState([{'image':Carousel3},{'image':Carousel4},{'image':Carousel1},{'image':Carousel2},{'image':Carousel6},{'image':Carousel9},{'image':Carousel5},{'image':Carousel7}]);
  useEffect(() => {
    setImageIndex(randomCount());
  }, []);

  return (
    <>
    <div className="has-background" style={{ backgroundImage: `url(${carouselImages[imageIndex|| 1].image})` }}>
      <div className="wrapper">
        <Container className="container wrapper__container verification-success">
          <Row>
            <Col lg={{ span: 6 }}>
              <div className="wrapper__container-card">
                <div className="wrapper__container-card-body">
                  <div className="success__card" role="alert" aria-live="polite">
                    <p className="success__card-text">
                      {t("pages.registration.verificationSuccess")}
                    </p>
                    <p className="success__card-text">
                      {t("pages.registration.subjectTitle")}
                      <span>
                        {" "}
                        "{t("pages.registration.verificationSuccessSubject")}"
                      </span>
                    </p>
                  </div>
                </div>
                <div className="separator" />
                <div className="text-center wrapper__container-card-register">
                  <Link to={getLoginUrl()}>{t("pages.registration.login")}</Link>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      </div>
    </>
  );

};

export default VerificationSuccess;
